import React, { useContext, useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../context/facebook_profiles/dashboard/DashboardContext";

// Components
import Dashboard from "./Dashboard/Dashboard";
import EditProfile from "./Profile/Edit";
import CreateProfile from "./Profile/Create";
import DeleteProfile from "./Profile/Delete";

// const useStyles = makeStyles((theme) => ({}));

const FacebookProfile = () => {
  // const classes = useStyles();
  const { getProfiles, getProfile, profiles, profile_form, selected_profile } =
    useContext(FacebookProfilesDashboardContext);

  const [page, setPage] = useState("Overview");

  const onChangeProfilePage = () => {
    const paths = window.location.pathname.split("/");

    if (paths.length >= 4) {
      if (paths[3] === "create") setPage("Create");
      else {
        getProfile(paths[3]);

        if (paths[4] === "edit") setPage("Edit");
        else setPage("Overview");
      }
    } else {
      setPage("Overview");
    }
  };

  useEffect(() => {
    // Retrieve Profile List
    getProfiles();

    // Set Page - Back Button Triggered
    window.addEventListener("popstate", () => onChangeProfilePage());

    // Set Page - On load
    onChangeProfilePage();
  }, []);

  useEffect(() => {
    // Set Page - Action Changed (Overview, Create, Edit)
    onChangeProfilePage();
  }, [profile_form.action]);

  useEffect(() => {
    // Product ID Not Found - Redirect To Facebook Profile
    const paths = window.location.pathname.split("/");

    if (page && paths.length > 3 && profiles) {
      if (paths[3] !== "create") {
        const list = Object.values(profiles).map((each) => {
          return each.profile_id;
        });

        const exist = list.includes(paths[3]);

        if (!exist) {
          window.location.replace(
            window.location.origin + `/${paths[1]}/${paths[2]}`
          );
        }
      }
    }
  }, [page, profiles, selected_profile]);

  return (
    <Grid container direction="row" spacing={1}>
      {page === "Overview" && <Dashboard />}
      {page === "Create" && <CreateProfile />}
      {page === "Edit" && selected_profile && <EditProfile />}
      {profile_form.action === "Delete" && selected_profile && (
        <DeleteProfile />
      )}
    </Grid>
  );
};

export default FacebookProfile;
